import React, { useState } from "react";
import CardTable from "../../../components/AdminTable/CardTable";
import Dropdown from "../../../components/AdminDropdown/Dropdown";

function CustomerFeedback() {
  const [columns] = useState([
    {
      header: "SN",
      accessorKey: "SN",
    
    },
    {
      header: "Name",
      accessorKey: "Name",
    },
    {
      header: "Email",
      accessorKey: "Email",
    },
    {
      header: "Phone",
      accessorKey: "Phone",
    },
    {
      header: "Comment",
      accessorKey: "Comment",
    },
    {
      header: "Date",
      accessorKey: "Date",
    },
    {
      header: "Added By",
      accessorKey: "AddedBy",
    },
    {
      header: "Actions",
      accessorKey: "total",
      cell: (row) => <Dropdown />,
    },

  ]);
  const [data] = useState([
   
  ]);
  const [buttonData] = useState([
    {
      buttonText: "Add Feedback ",
      path: "addCustomerFeedbackForm"
    },
  ]);
 
  return (
    <main>
      <CardTable
        data={data}
        columns={columns}
        heading={"Customer Feedback"}
        buttonData={buttonData}
      />
    </main>
  );
}

export default CustomerFeedback;
